import { LocalizedDatePipe } from '../../../shared/pipe/localized-date.pipe';
import { CommonModule, DecimalPipe } from '@angular/common';
import {
  Component,
  DestroyRef,
  OnInit,
  computed,
  inject,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { DataStateComponent } from '../../../shared/components/ui/data-state/data-state.component';
import { PageHeaderComponent } from '../../../shared/components/ui/page-header/page-header.component';
import { UserCellComponent } from '../../../shared/components/ui/user-cell/user-cell.component';
import { fullName } from '../../../shared/helpers/user.helpers';
import { toErrorMessage } from '../../../shared/helpers/http-error';
import { OwnersService } from '../../../shared/services/owners.service';
import { VehicleOwner } from '../../../shared/types/owner.types';

@Component({
  selector: 'app-owner-detail',
  imports: [
    CommonModule,
    RouterModule,
    LocalizedDatePipe,
    DecimalPipe,
    PageHeaderComponent,
    DataStateComponent,
    UserCellComponent,
  ],
  templateUrl: './owner-detail.component.html',
})
export class OwnerDetailComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly ownersService = inject(OwnersService);
  private readonly destroyRef = inject(DestroyRef);

  readonly owner = signal<VehicleOwner | null>(null);
  readonly loading = signal(true);
  readonly loadError = signal<string | null>(null);

  readonly isCompany = computed(() => this.owner()?.ownerType === 'COMPANY');
  readonly displayName = computed(() => {
    const o = this.owner();
    if (!o) return '';
    return o.businessName || fullName(o.user ?? null) || `Propriétaire #${o.id}`;
  });

  private id!: number;

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get('id');
    const parsed = idParam ? Number(idParam) : NaN;
    if (!Number.isFinite(parsed)) {
      this.loadError.set('Identifiant invalide.');
      this.loading.set(false);
      return;
    }
    this.id = parsed;
    this.fetch();
  }

  fetch(): void {
    this.loading.set(true);
    this.loadError.set(null);
    this.ownersService
      .get(this.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (o) => {
          this.owner.set(o);
          this.loading.set(false);
        },
        error: (err: unknown) => {
          this.loading.set(false);
          this.loadError.set(
            toErrorMessage(err, 'Impossible de charger ce propriétaire.'),
          );
        },
      });
  }
}
